import {Answer} from './answer';
import {JsonObject, JsonProperty} from 'json2typescript';
import {Click} from './click';


@JsonObject('Respondent')
export class Respondent {
    @JsonProperty('id',Number)
    Id = 0;

    // video:string;
    @JsonProperty('identifier')
    Identifier = '';

    // TODO: Obsolete
    @JsonProperty('synchro_id',Number)
    SynchroId = 0;

    @JsonProperty('language',String)
    Language = '';

    @JsonProperty('project_id',Number)
    ProjectId = 0;

    @JsonProperty('terminal_id',Number)
    TerminalId = 0;

    @JsonProperty('questionnaire_id',Number)
    QuestionnaireId = 0;

    @JsonProperty('device_type_id',Number)
    DeviceTypeId = 0;

    @JsonProperty('device_id',Number)
    DeviceID = 0 ;

    // obsolete
    @JsonProperty('device_ip',String)
    DeviceIP = '';

    // obsolete
    @JsonProperty('device_name',String)
    DeviceName = '';
    // TODO: This is to be removed
    // medias: Media[] = null;
  // TODO: This is to be removed
    @JsonProperty('clicks',[Click])
     clicks: Click[] = [];

    // TODO: To be removed
    // @JsonProperty('email_status',String)
    // emailStatus = '';

    @JsonProperty('inserted_local_time',String)
    insertedTime = '';

    @JsonProperty('time_zone',String)
    timeZone = '';

    @JsonProperty('responses',[Answer])
    Answers:Answer[] = [];// TSMap<number,Answer>;  // {[key: number]: Answer[]} = {};

    @JsonProperty('size_on_disk',Number)
    sizeOnDisk = 0;

    @JsonProperty('email_opened',Boolean)
    emailOpened = false;

    @JsonProperty('token',String)
    token = '';

    @JsonProperty('emailConfigPath',String,true)
    path = '';

    constructor() {

    }


    public getResponse(qNo:number):Answer {
      for(const ans of this.Answers) {
        if(ans.questionNo === qNo) {
          return ans;
        }
      }
      return null;
    }

    public setResponse(qNo:number,answer:string) {
       let set = false;
      for(const ans of this.Answers) {
        if(ans.questionNo === qNo) {
            if(typeof answer === 'boolean') {
                if(answer) {
                    ans.answer = '1';
                } else {
                    ans.answer = '0';
                }
            } else {
                ans.answer = answer;
            }
          set = true;
        }
      }

      if(!set) {
          const ans = new Answer();
          ans.questionNo=qNo;
          ans.choiceNo = 1;
          if(typeof answer === 'boolean') {
              if(answer) {
                  ans.answer = '1';
              }
          } else {
              ans.answer = answer;
          }
          this.Answers.push(ans);
      }
    }
}
